import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class CustomerSubTypeReferenceService extends BaseReferenceService {
  constructor() {
    super('customerSubTypeReference');
  }
}
